import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchServicesPage } from '../helpers/contentfulHelper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import styles from '../styles/ServicesPage.module.css';

const ServicesPage = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const load = async () => {
      const data = await fetchServicesPage();
      setPage(data);
    };
    load();
  }, []);

  if (!page) return null;

  const { title, introCopy, services } = page.fields;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {/* Top copy */}
        <h1 className={styles.title}>{title}</h1>

        <div className={styles.intro}>
          {documentToReactComponents(introCopy)}
        </div>

        {/* Services grid */}
        <div className={styles.grid}>
          {services.map((service) => {
            const { title, excerpt, image, ctaLabel, slug } = service.fields;

            return (
              <div key={service.sys.id} className={styles.card}>
                <img
                  src={image.fields.file.url}
                  alt={title}
                  className={styles.image}
                />

                <h2 className={styles.cardTitle}>{title}</h2>

                <p className={styles.excerpt}>{excerpt}</p>

                <Link
                    to={`/services/${slug}`}
                    className={styles.button}
                    >
                    {ctaLabel || 'View more'}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;